import React from "react";
import { Box, Text, SimpleGrid, useColorModeValue, Button, Spinner } from "@chakra-ui/react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Label } from "recharts";
import theme from "../../theme";
import "./chartStyles.css";

const ProgressBar = ({
  data,
  title,
  caption,
  explanation,
  value,
  action,
  unit = "%",
  legend = true,
  chartColors = Object.values(theme.colors.chartColors),
}) => {
  const dataWithPercentage = data.map((item) => ({
    ...item,
    percent:
      unit === "%"
        ? (
            (item.value / data.reduce((acc, curr) => acc + curr.value, 0)) *
            100
          ).toFixed(2)
        : item.value,
  }));

  const bgColor = useColorModeValue("chart-box", "chart-box-dark");

  const values = Array.isArray(value) ? value : value ? [value] : [];

  return (
    <Box className={`${bgColor} chart-hover-effect`}>
      {title && (<Text mb={3} fontSize="xl" fontWeight="600">
        {title}
      </Text>)}
      {caption && (<Text>{caption}</Text>)}

      {(title || caption) && (<Box className="divider" />)}

      <Box
        className="chart-pie-legend"
        display="flex"
        flexDirection={{ base: "column", md: "row" }}
        alignItems="center"
        mt={4}
      >
        <ResponsiveContainer width={legend ? "60%" : "100%"} height={300} minWidth="200px">
          <PieChart>
            <Pie
              data={data}
              startAngle={180}
              endAngle={0}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={100}
              dataKey="value"
              label={false}
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={chartColors[index % chartColors.length]}
                />
              ))}
              {values.map((v, i) => (
                <Label
                  key={i}
                  value={v.text}
                  position="center"
                  fill={v.color || "#000"}
                  style={{
                    fontSize: v.fontSize || "1.6rem",
                    fontWeight: "bold",
                  }}
                  dy={-20 + i * 35}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>

        {legend && (
          <Box className="chart-pie-legend">
            <SimpleGrid columns={2} spacing={3} minWidth="250px" width="100%">
              {dataWithPercentage.map((entry, index) => (
                <React.Fragment key={index}>
                  <Box display="flex" alignItems="center" minWidth="120px">
                    <Box
                      className="legend-bullet"
                      backgroundColor={chartColors[index % chartColors.length]}
                      mr={2}
                    />
                    <Text className="legend-text" noOfLines={1}>
                      {entry.name}
                    </Text>
                  </Box>
                  <Text fontSize="md" color={useColorModeValue("#615E83", "#D1D1D1")}>
                    {unit !== "%" ? unit : ""}
                    {entry.percent}
                    {unit === "%" ? unit : ""}
                  </Text>
                </React.Fragment>
              ))}
            </SimpleGrid>
          </Box>
        )}
      </Box>
        {action?.click && (
          <Box display="flex" justifyContent="center" mt={-20}>
            <Button
              onClick={action.click}
              colorScheme="blue"
              isLoading={action.isLoading}
              isDisabled={action.isDisabled}
            >
              {action.text}
            </Button>
          </Box>
        )}
      

      {/* Explanation text below the button */}
      {explanation && <Text mt={4}>{explanation}</Text>}
    </Box>
  );
};

export default ProgressBar;
